"use strict";

exports.__esModule = true;
exports.DownloadCommentsSection = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactCsv = require("react-csv");
var _Translator = require("../../Core/Translator");
var _FormattedPlantDate = require("../../Time/FormattedPlantDate");
var _TimeContext = require("../../Time/TimeContext");
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DownloadCommentsSectionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DownloadCommentsSection__DownloadCommentsSectionWrapper",
  componentId: "sc-lzsz06-0"
})([""]);
var formatCommentDetails = function formatCommentDetails(comments) {
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  return comments.map(function (_ref) {
    var creator = _ref.creator,
      created = _ref.created,
      body = _ref.body;
    return {
      Creator: creator,
      "Created at": (0, _FormattedPlantDate.formatDateString)(created, {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: time.timezone.name
      }),
      Comment: body
    };
  });
};
var DownloadCommentsSection = exports.DownloadCommentsSection = function DownloadCommentsSection(_ref2) {
  var comments = _ref2.comments,
    ticketId = _ref2.ticketId;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var formattedComments = formatCommentDetails(comments);
  return /*#__PURE__*/_react["default"].createElement(DownloadCommentsSectionWrapper, {
    "data-testid": "DownloadCommentsSection"
  }, comments.length > 0 ? /*#__PURE__*/_react["default"].createElement(_reactCsv.CSVLink, {
    data: formattedComments,
    "data-testid": "DownloadCommentsButton",
    className: _core.Classes.BUTTON + " " + _core.Classes.MINIMAL + " " + _core.Classes.INTENT_PRIMARY,
    filename: "ticket-" + ticketId + ".csv",
    target: "_blank",
    rel: "noopener noreferrer",
    disabled: true
  }, translate("DownloadTicketSection.download", "Download Comments")) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    intent: "primary",
    "data-testid": "DownloadCommentsButton",
    disabled: true,
    text: translate("DownloadTicketSection.download", "Download Comments")
  }));
};